import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import CrmAiCallsAPI from '../../../api/crm/aiCalls';

export const state = {
    records: [],
    settings: {
        webhook_url: '',
        ai_script: '',
        templates: [],
    },
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getAiCalls(_state) {
        return _state.records;
    },
    getAiCallById: _state => id => {
        return _state.records.find(r => r.id === Number(id));
    },
    getSettings(_state) {
        return _state.settings;
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_CRM_AI_CALLS_UI_FLAG, { isFetching: true });
        try {
            const response = await CrmAiCallsAPI.get();
            commit(types.SET_CRM_AI_CALLS, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_CRM_AI_CALLS_UI_FLAG, { isFetching: false });
        }
    },
    show: async (_, id) => {
        const response = await CrmAiCallsAPI.show(id);
        return response.data;
    },
    create: async ({ commit }, callObj) => {
        commit(types.SET_CRM_AI_CALLS_UI_FLAG, { isCreating: true });
        try {
            const response = await CrmAiCallsAPI.create(callObj);
            commit(types.ADD_CRM_AI_CALL, response.data);
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            commit(types.SET_CRM_AI_CALLS_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_CRM_AI_CALLS_UI_FLAG, { isUpdating: true });
        try {
            const response = await CrmAiCallsAPI.update(id, updateObj);
            commit(types.EDIT_CRM_AI_CALL, response.data);
        } catch (error) {
            throw error;
        } finally {
            commit(types.SET_CRM_AI_CALLS_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_CRM_AI_CALLS_UI_FLAG, { isDeleting: true });
        try {
            await CrmAiCallsAPI.delete(id);
            commit(types.DELETE_CRM_AI_CALL, id);
        } catch (error) {
            throw error;
        } finally {
            commit(types.SET_CRM_AI_CALLS_UI_FLAG, { isDeleting: false });
        }
    },
    dispatch: async ({ commit }, id) => {
        try {
            const response = await CrmAiCallsAPI.dispatch(id);
            commit(types.EDIT_CRM_AI_CALL, response.data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getSettings: async ({ commit }) => {
        try {
            const response = await CrmAiCallsAPI.getSettings();
            commit(types.SET_CRM_AI_CALL_SETTINGS, response.data);
        } catch (error) {
            // Ignore error
        }
    },
    updateSettings: async ({ commit }, settings) => {
        try {
            const response = await CrmAiCallsAPI.updateSettings(settings);
            commit(types.SET_CRM_AI_CALL_SETTINGS, response.data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export const mutations = {
    [types.SET_CRM_AI_CALLS_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [types.SET_CRM_AI_CALLS]: MutationHelpers.set,
    [types.ADD_CRM_AI_CALL]: MutationHelpers.create,
    [types.EDIT_CRM_AI_CALL]: MutationHelpers.update,
    [types.DELETE_CRM_AI_CALL]: MutationHelpers.destroy,
    [types.SET_CRM_AI_CALL_SETTINGS](_state, data) {
        _state.settings = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
